"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResultStateProvider = void 0;

var react_1 = __importDefault(require("react"));

var StateProvider_1 = __importDefault(require("@appbaseio/reactivesearch/lib/components/basic/StateProvider"));

var ResultStateProvider = function ResultStateProvider(props) {
  return react_1.default.createElement(StateProvider_1.default, {
    componentIds: ["page"],
    includeKeys: ["isLoading", "hits", "resultStats", "error"],
    render: function render(state) {
      var RenderComponent = props.render;
      return react_1.default.createElement(RenderComponent, Object.assign({}, state.searchState.page));
    }
  });
};

exports.ResultStateProvider = ResultStateProvider;